<script>
  import { onMount } from 'svelte';
   import Modal from './modal.svelte'
   export let modal
   
   const modalId = modal.id.replace('#', '')

</script>

<Modal id={modalId}>
   <div class="popup-get-started-content">
      {#if modal.content}
         {@html modal.content}
      {/if}
      <div class="btns-wrap d-sm-flex justify-content-center" style="margin-top: 1rem;">
         {#if modal.buttons}
         {#each modal.buttons as link}
         <a href={link.link.url} target={link.link.target ? link.link.target : '_self'} class="btn">
            <span>{link.link.title ? link.link.title : 'Learn More'}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
               <polygon points="11.293 4.707 17.586 11 4 11 4 13 17.586 13 11.293 19.293 12.707 20.707 21.414 12 12.707 3.293 11.293 4.707"></polygon>
            </svg>
         </a>
         {/each}
         {/if}
      </div>
   </div>
</Modal> 
